import {FetchResult, MutationFunctionOptions, useQuery} from '@apollo/client'
import {isEmpty, pick} from 'lodash-es'
import {parseCookies} from 'nookies'
import {useEffect} from 'react'
import {Control, FieldValues, useWatch} from 'react-hook-form'
import {GET_COUNTRIES} from '_app/graphql/queries/customer/GetCountries'
import {CheckoutCartResponse} from '_app/graphql/types'
import {FAKE_ADDRESS, INPOST_METHOD} from '../constants'
import CookiesHelper from '../../../helpers/CookiesHelper/CookiesHelper'

interface UseCheckout {
    setShippingAddressesOnCart: (
        options: MutationFunctionOptions
    ) => Promise<FetchResult>;
    control: Control<FieldValues>;
    data: CheckoutCartResponse | undefined;
    defaultValue: string;
}

const useCheckout = ({
                         setShippingAddressesOnCart,
                         control,
                         data,
                         defaultValue = 'PL',
                     }: UseCheckout) => {
    const destination = useWatch({
        control,
        name: 'shipping_addresses[0].country.code',
        defaultValue,
    })

    const shippingCarrierCode = useWatch({
        control,
        name: 'shipping_addresses[0].selected_shipping_method.method_code',
        defaultValue: '',
    })

    const isParcelOrShowroom = ['showroom', INPOST_METHOD].includes(
        shippingCarrierCode
    )

    const {data: countriesData} = useQuery(GET_COUNTRIES)

    useEffect(() => {
        if (destination && data) {
            const countryRegion = (countriesData?.countries || []).find(
                (country: { id: string }) => country.id === destination
            )?.available_regions?.[0]

            const shippingAddress = pick(data?.cart?.shipping_addresses?.[0], [
                'firstname',
                'lastname',
                'company',
                'telephone',
                'postcode',
                'city',
                'street',
                'vat_id',
            ])

            const isFakeAddress = shippingAddress?.firstname === 'firstname'

            setShippingAddressesOnCart({
                variables: {
                    cartId: CookiesHelper.get('cartId'),
                    shippingAddresses: [
                        {
                            address: {
                                ...(isFakeAddress || isEmpty(shippingAddress)
                                    ? FAKE_ADDRESS
                                    : shippingAddress),
                                country_code: destination,
                                region_id: countryRegion?.id,
                                region: countryRegion?.code,
                            },
                        },
                    ],
                },
                refetchQueries: ['GetCart'],
            })
        }
    }, [destination, data, isParcelOrShowroom, countriesData?.countries])
}

export default useCheckout
